import React, { useEffect, useRef, useState } from 'react';
import useIsDesktop from '../../../utils/hooks/useIsDesktop';
import createAccordion from '../../../cmscomponents/accordion/accordion';
import { decodeHtml } from '../../../utils/helpers';

const { productsTitle, productsDescription } = window.inlinePlp;

const PlpCategoryDetails = () => {
  const { isDesktop } = useIsDesktop();
  const accordionRef = useRef(null);
  const [accordion, setAccordion] = useState(null);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const isExpanded = () => {
    return accordion && accordion.isTabOpened(0);
  };

  const headerClickHandler = () => {
    if (isExpanded()) {
      accordion?.closePanel(0);
      setIsAccordionOpen(false);
    } else {
      accordion?.openPanel(0);
      setIsAccordionOpen(true);
    }
  };

  useEffect(() => {
    if (!isDesktop && accordionRef.current) {
      const options = {
        attachClickListenersManually: true,
      };
      const newAccordion = createAccordion(accordionRef.current, options).init();
      setAccordion(newAccordion);
    }
  }, [isDesktop]);

  if (isDesktop) {
    return (
      <div className="plp-category-text">
        {productsTitle && (
          <h1
            className="category-page-title"
            dangerouslySetInnerHTML={{ __html: decodeHtml(productsTitle).replace(/\\n/g, '') }}
          />
        )}
        {productsDescription && (
          <div className="category-page-description">
            <p
              className="category-page-description__text"
              dangerouslySetInnerHTML={{ __html: decodeHtml(productsDescription).replace(/\\n/g, '') }}
            />
          </div>
        )}
      </div>
    );
  }

  if (!productsTitle) {
    return null;
  }

  return (
    <div className="plp-category-text">
      <dl className="accordion plp-category-accordion" ref={accordionRef}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
        <dt className="accordion-header" onClick={headerClickHandler}>
          {productsTitle && (
            <h1
              className="category-page-title"
              dangerouslySetInnerHTML={{ __html: decodeHtml(productsTitle).replace(/\\n/g, '') }}
            />
          )}
          {productsDescription && <i className={`fa-regular fa-chevron-down ${isAccordionOpen ? 'active' : ''}`} />}
        </dt>
        <dd className="accordion-item accordion-panel">
          {productsDescription && (
            <div className="category-page-description">
              <p
                className="category-page-description__text"
                dangerouslySetInnerHTML={{ __html: decodeHtml(productsDescription).replace(/\\n/g, '') }}
              />
            </div>
          )}
        </dd>
      </dl>
    </div>
  );
};

export default PlpCategoryDetails;
